<template>
  <div class="message-info">
    <div class="message-title">
      <div class="title-default">消息通知</div>
      <div class="message-tab">
        <div class="message-tabs">
          <div
            class="tabs"
            :class="{ selected: service }"
            @click="messageSwitch('SERVICE_MESSAGE')"
          >
            服务消息({{ messageList.serviceMesTotal }})
          </div>
          <div
            class="tabs"
            :class="{ selected: system }"
            @click="messageSwitch('SYS_MESSAGE')"
          >
            系统消息({{ messageList.sysMesTotal }})
          </div>
          <div
            class="tabs"
            :class="{ selected: gaiyue }"
            @click="messageSwitch('gaiyue')"
          >
            改约提醒({{ messageList.updateAppointTotal||0 }})
          </div>
        </div>
        <div class="total" @click="allRead">
          全部未读({{ messageList.unReadNum }})
        </div>
      </div>
      <div class="message-list">
        <div class="null" v-show="messageList.pageResult.total == 0">
          <img src="../../assets/img/pic_none.png" alt />
          <div>没有相关消息</div>
        </div>
        <div class="message-service">
          <div
            class="message-item"
            v-for="(item, index) in messageList.pageResult.rows"
            @click="openDetail(item)"
          >
            <div class="message-item-title">
              <div class="hongdian" v-if="!item.isRead"></div>
              {{ item.title }}
              <span>{{
                new Date(item.createTime).format("yyyy-MM-dd HH:mm:ss")
              }}</span>
            </div>
            <div class="message-item-content">
              <div class="message-item-text">
                {{ getSimpleText(item.content) }}
              </div>
              <div class="view-details">
                查看详情
                <svg class="icon" aria-hidden="true">
                  <use xlink:href="#iconbiaodan_rili_right" />
                </svg>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-pagination
      v-show="messageList.pageResult.total > 12"
      class="fenye commodity-fenye"
      background
      layout="prev, pager, next"
      :total="messageList.pageResult.total"
      :page-size="12"
      @current-change="pageSize"
    ></el-pagination>
    <orderInfo-modal ref="orderInfoModal"></orderInfo-modal>
  </div>
</template>

<script>
import orderInfoModal from "./modules/orderInfoModal";

export default {
  components: { orderInfoModal },
  data() {
    return {
      service: true,
      system: false,
      gaiyue: false,
      page: 1,
      serviceType: "SERVICE_MESSAGE",
      messageList: {
        pageResult: {
          rows: [],
        },
      },
    };
  },
  mounted() {
    var _this = this;
    this.$store.state.badge = true;
    if (Cookies.get("token") != undefined) {
      if(this.$route.params.type) this.messageSwitch('gaiyue');
      else this.getMessageList();
      
    }
  },

  methods: {
    allRead() {
      let _this = this;
      this.$confirm("确定要全部已读吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$put(`/user/api/mes/all_read?type=${_this.serviceType=='gaiyue'?'SERVICE_MESSAGE':_this.serviceType}&title=${_this.serviceType=='gaiyue'?'无人接单':''}`).then(
            (res) => {
              _this.getMessageList();
            }
          );
          this.$message({
            type: "success",
            message: "成功!",
          });
        })
        .catch(() => {});
    },
    //html剔除富文本标签，留下纯文本
    getSimpleText(html) {
      return html.replace(/<[^<>]+>/g, "").replace(/&nbsp;/gi, "");
    },
    pageSize(val) {
      this.page = val;
      this.getMessageList();
    },
    getMessageList() {
      var _this = this;
      if (this.serviceType == "gaiyue") {
        this.$post(
          `/order/api/order/mes/list?pageIndex=${this.page}&pageSize=12&title=无人接单`
        ).then((res) => {
          if (res.code == 0) {
            _this.messageList = res.data;
          } else {
            this.$message(res.message);
          }
        });
      } else {
        this.$post(
          `/user/api/mes/list?pageIndex=${this.page}&pageSize=12&type=${this.serviceType}`
        ).then((res) => {
          if (res.code == 0) {
            _this.messageList = res.data;
          } else {
            this.$message(res.message);
          }
        });
      }
    },
    messageSwitch(tab) {
      this.system = false;
      this.service = false;
      this.gaiyue = false;
      this.serviceType = tab;
      if (tab == "SERVICE_MESSAGE") {
        this.service = true;
      }
      if (tab == "SYS_MESSAGE") {
        this.system = true;
      }
      if (tab == "gaiyue") {
        this.gaiyue = true;
      }
      this.getMessageList(tab);
    },
    openDetail(item) {
      console.log(item);
      this.$put(`/user/api/mes/modify?id=${item.id}`).then((res) => {
        if (res.code == 0) {
          this.getMessageList();

          if (this.service) {
            // this.$router.push({
            //   path: "/user/order/orderinfo",
            //   query: { orderid: item.mesAssociatedId }
            // });
            this.$refs.orderInfoModal.open({ id: item.mesAssociatedId });
          } else {
            this.$router.push({ name: "msgDetail", params: item });
          }
        } else {
          this.$message(res.message);
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.message-info {
  .title-default {
    border-bottom: 1px solid #e8eef5;
    background: #ffffff;
  }
  .message-tab {
    background: #ffffff;
    padding: 0px 20px;
    font-size: 14px;
    color: #2f3133;
    display: flex;
    // align-items: center;
    justify-content: space-between;
  }
  .message-tabs {
    display: flex;
    padding: 14px 0px;
  }
  .tabs {
    margin-right: 36px;
    cursor: pointer;
  }
  .total {
    color: #5e6066;
    font-size: 12px;
    padding: 17px 0;
    cursor: pointer;
  }
  .total:hover {
    color: #2f3133;
  }
  .selected {
    color: #3455d3;
    font-weight: bold;
    border-bottom: 1px solid #3455d3;
    padding-bottom: 3px;
  }
  .message-list {
    .message-service {
      .message-item {
        margin-top: 10px;
        cursor: pointer;
        .message-item-title {
          position: relative;
          height: 44px;
          background: #f9fafa;
          color: #2f3133;
          font-size: 14px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          border-bottom: 1px solid #dfe4eb;
          padding: 0 20px;
          span {
            color: #909399;
            font-size: 12px;
          }
          .hongdian {
            position: absolute;
            width: 5px;
            height: 5px;
            background: #f75658;
            border-radius: 50%;
            top: 10px;
            left: 10px;
          }
        }
        .message-item-content {
          height: 60px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          background: #ffffff;
          padding: 0 20px;
          color: #909399;
          font-size: 12px;
          .view-details {
            cursor: pointer;
          }
        }
        .message-item-text {
          color: #5e6066;
          width: 739px;
          overflow: hidden;
          max-height: 36px;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
        .message-system {
          height: 80px;
          .message-item-text {
            color: #5e6066;
            width: 739px;
            height: 40px;
            overflow: hidden;
            text-overflow: clip;
          }
        }
      }
    }
  }
}
</style>
